import React from "react";

const CopyProgressModal = ({ isOpen, progress, onClose }) => {
  if (!isOpen) return null;

  const {
    currentStep,
    totalSteps,
    scanCreation,
    currentIssue,
    isComplete,
    error,
  } = progress;

  let modalTitle = "";
  if (isComplete) {
    modalTitle = "Copy Complete!";
  } else if (error) {
    modalTitle = "Copy Failed";
  } else {
    modalTitle = "Copying to New Scan";
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium text-gray-900">{modalTitle}</h3>
          {(isComplete || error) && (
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              ×
            </button>
          )}
        </div>

        {error ? (
          <div className="text-red-600 mb-4">
            <p className="font-medium">Error:</p>
            <p className="text-sm">{error}</p>
          </div>
        ) : (
          <>
            {/* Progress Bar */}
            <div className="mb-4">
              <div className="flex justify-between text-sm text-gray-600 mb-1">
                <span>Progress</span>
                <span>
                  {currentStep}/{totalSteps}
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                  style={{
                    width: `${Math.min(
                      (currentStep / totalSteps) * 100,
                      100
                    )}%`,
                  }}
                ></div>
              </div>
            </div>

            {/* Current Status */}
            <div className="space-y-2 text-sm">
              {scanCreation && (
                <div className="flex items-center">
                  <div className="w-4 h-4 mr-2">
                    {scanCreation.status === "complete" ? (
                      <span className="text-green-600">✓</span>
                    ) : scanCreation.status === "progress" ? (
                      <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-blue-600"></div>
                    ) : (
                      <span className="text-gray-400">○</span>
                    )}
                  </div>
                  <span
                    className={
                      scanCreation.status === "complete"
                        ? "text-green-600"
                        : "text-gray-900"
                    }
                  >
                    Creating scan: {scanCreation.title}
                  </span>
                </div>
              )}

              {currentIssue && (
                <div className="flex items-center">
                  <div className="w-4 h-4 mr-2">
                    {currentIssue.status === "complete" ? (
                      <span className="text-green-600">✓</span>
                    ) : currentIssue.status === "progress" ? (
                      <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-blue-600"></div>
                    ) : (
                      <span className="text-gray-400">○</span>
                    )}
                  </div>
                  <span
                    className={
                      currentIssue.status === "complete"
                        ? "text-green-600"
                        : "text-gray-900"
                    }
                  >
                    Copying issue {currentIssue.index}/{currentIssue.total}:{" "}
                    {currentIssue.title}
                  </span>
                </div>
              )}
            </div>
          </>
        )}

        {isComplete && (
          <div className="mt-4 flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
            >
              Done
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CopyProgressModal;
